import ProductCard from '@tvg/fuse-design/simple-product-card';
import styled from 'styled-components';

export const StyledProductCard = styled(ProductCard)`
  .fuse-price__save-price {
    display: none;
  }
`;

export default {};
